import React, { useContext, useEffect, useRef, useState } from "react"
import { ApiGetCall, ApiPostCall, ApiGetHeaders, ApiGetCDNData, ApiCmnHeadersGetCall } from "../../JS/Connector";
import { CamelCaseWithSpaces, CustomParseSafeHtml, formatDateToUsaMMDDYYYY, getTypeWatchDelay, LogInSchoolID, LogInUserID, trackingHandle, shipStationUrlTrack, transformNameOfCol, typewatch } from "../../JS/Common";
import Pagination from "react-js-pagination";
import { useLocation, useNavigate } from "react-router-dom";
import AlertsComp from "../../Components/AlertsComp";
import Deletepopup from "../../Components/Deletepopup";
import { faPencilAlt, faShippingFast } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CreateShippingCom from "../../Components/CreateShippingCom";
import Cookies from "js-cookie";
import jinja from "jinja-js";
import html2pdf from "html2pdf.js";
import CustomizationPopup from "../../Components/CustomizationPopup";
import BatchDetailsPopup from "../../Components/BatchDetailsPopup";
import { ThemeContext, UserContext } from "../../App";
import SignatureCanvas from "react-signature-canvas";
import PageHead from "../../Components/PageHead";
import Popup from "../../Components/Popup";
import { log } from "../../JS/Logger";
import { useSelector } from "react-redux";
import useConfig from "../../Hooks/useConfig";
import TrackingDetailsPopup from "../../Components/TrackingDetailsPopup";
import { useStickyAction } from "../../Hooks";

function Outgoingbatches() {
    const { origin_flag, adminCallNode } = useConfig();
    const { state } = useContext(ThemeContext);
    const StateData = useSelector((state) => state.authData);
    const [Batches, setBatches] = useState([]);
    const [loading, setLoading] = useState(false);
    const [Alerts, setAlerts] = useState("");
    const [AttachTicketData, setAttachTicketData] = useState([]);
    const [BatchParams, setBatchParams] = useState({
        BatchTicketDataModal: false,
        BatchId: '',
        SortbyFlag: 'desc',
        searchString: '',
        BatchName: ''
    });
    const [SortbyKey, setSortbyKey] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const showPagination = Batches.length > 0;
    const [deletePopup, setDeletePopup] = useState(false);
    const navigate = useNavigate()
    const [createbatch, setCreatebatch] = useState(false)
    const schoolDetail = state?.ShippingType
    const [CustomizationModal, setCustomizationModal] = useState(false)
    const [deleteShipmentPopup, setDeleteShipmentPopup] = useState(false)
    const [columnNames, setColumnNames] = useState([]);
    const [batchData, setBatchData] = useState({
        batchName: '',
        batchNote: ''
    })
    var schoolname = Cookies.get('ShipSchoolName')
    const sigCanvasForPackedBy = useRef({});
    const [signatureModal, setSignatureModal] = useState(false)
    const [SignatureDataForPackedBy, setSignatureDataForPackedBy] = useState('')
    const [ReceivedData, setReceivedData] = useState({
        receivedname: '',
        receiveddate: ''
    })
    const { UserData } = useContext(UserContext);
    const [deletedData, setDeletedData] = useState({
        trackingnum: "",
        batchId: ""
    })
    const initialTrackSate = {
        show: false,
        BatchId: null
    }
    const [showTrackingModal, setShowTrackingModal] = useState(initialTrackSate);
    if (schoolname) {
        schoolname = decodeURIComponent(schoolname);
    }
    const location = useLocation();
    useEffect(() => {
        AllBatches(BatchParams.searchString ? BatchParams.searchString : null, SortbyKey ? SortbyKey : null, false);
    }, [currentPage, LimitForPagination]);
    useEffect(() => {
        if (location.state) {
            navigate(location.pathname, { replace: true });
        }
        ApiGetHeaders(4, setColumnNames)
    }, [])

    const { tableWrapperRef, isOverflowing } = useStickyAction(columnNames);

    function renderContentForColumn(columnName, item) {
        const contentMap = {
            "BatchName": <span>
                <u className="cursor-pointer" title="Show Ticket History" onClick={(e) => ShowTicketDataForBatch(item.id)} batchid={item.id}>{item.batch_name}</u>
            </span>,
            "TrackingNum": <span className="cursor-pointer">
                {item.tracking_num != null ? <u title="Show Tracking Information" onClick={(e) => setShowTrackingModal(prev => ({ ...prev, show: true, BatchId: item?.id }))}>{item.tracking_num}</u> : <>-</>}
            </span>,
            "created_at": item.created_at ? formatDateToUsaMMDDYYYY(item.created_at) : '-',
            "Notes": <div className="note-wrap">{item.notes || '-'}</div>,
            "Total_Devices": item.school_batch_log_count || '-',
        };
        return contentMap[columnName] || null;
    }
    async function AllBatches(searchString, SortKey, toogleSort) {
        if (!searchString) searchString = null;
        if (SortKey && toogleSort) BatchParams.SortbyFlag = BatchParams.SortbyFlag == "asc" ? "desc" : "asc";
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`/schools/batches/all?schoolId=${LogInSchoolID}&search=${searchString}&sortBy=${SortKey}&sortByOrder=${BatchParams.SortbyFlag}&page=${currentPage}&limit=${LimitForPagination}&flag=3`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false);
                    const responseRs = JSON.parse(result);
                    setpageRangeCount(responseRs.total)
                    setBatches(responseRs.data.length ? responseRs.data : [])
                }
            });
        }, getTypeWatchDelay(searchString, 500));

    }
    async function ShowTicketDataForBatch(batchId) {
        setLoading(true)
        setBatchParams({ ...BatchParams, BatchTicketDataModal: true, BatchId: batchId });
        await ApiGetCall(`/schools/batches/data-by-id?batchId=${batchId}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false)
                const responseRs = JSON.parse(result);
                setBatchData({ ...batchData, batchName: responseRs?.batch_name, batchNote: responseRs?.batch_notes })
                if (responseRs.ticket.length != 0) {
                    setAttachTicketData(responseRs.ticket);
                } else {
                    setAttachTicketData([]);
                }
            }
        });
    }

    async function ExtraDocument(FedExQr) {
        ApiGetCDNData("/" + FedExQr, StateData?.Schoolnumber).then((blob) => {
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
        });
    };
    async function DeleteBatch() {
        setLoading(true);
        var raw = JSON.stringify({
            flag: 1,
            batchId: BatchParams.BatchId,
            schoolId: LogInSchoolID,
        });
        await ApiPostCall(`${adminCallNode}/billing/batches/delete`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setDeletePopup(false);
                const ResponseRs = JSON.parse(result);
                if (ResponseRs?.response == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={ResponseRs?.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                        AllBatches(BatchParams.searchString ? BatchParams.searchString : null, null, false);
                    }, 1500);
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={ResponseRs?.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    function PrintPackingList(batchid) {
        setLoading(true)
        fetch(`${origin}/PackingList.html`)
            .then(response => response.text())
            .then(templateText => jinja.compile(templateText))
            .then(template => {
                ApiCmnHeadersGetCall(`/schools/batches/print-list?batchId=${batchid}`)
                    .then(response => JSON.parse(response))
                    .then(data => {
                        const formattedDate = new Date(data.createdAt).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                        });
                        const rendered = template.render({ data, formattedDate });
                        const pdfContent = CustomParseSafeHtml(rendered, false);
                        pdfContent.style.padding = '20px';
                        html2pdf().from(pdfContent).save();
                        setLoading(false)
                    })
                    .catch(error => {
                        setLoading(false)
                        log.error('Error loading data from API', error);
                    });
            })
            .catch(error => {
                setLoading(false)
                log.error('Error loading template', error);
            });
    }
    const handleSortClick = (item) => {
        if (item == 'Total_Devices') {
            item = 'count'
        } else if (item == 'BatchName') {
            item = 'batch_name'
        } else if (item == 'TrackingNum') {
            item = 'tracking_num'
        } else if (item == 'Notes') {
            item = 'notes'
        }
        if (item !== 0) {
            AllBatches(BatchParams.searchString, item, true);
            setSortbyKey(item)
        }
    };
    const clearSignatureForPackedBy = () => {
        if (SignatureDataForPackedBy != null) {
            setSignatureDataForPackedBy(null)
        } else {
            sigCanvasForPackedBy.current.clear();
        }
    };
    async function SaveSignatureCall() {
        var signatureBase64 = null;

        if (SignatureDataForPackedBy == null) {
            signatureBase64 = sigCanvasForPackedBy.current.isEmpty() ? null : sigCanvasForPackedBy.current.getTrimmedCanvas().toDataURL("image/png");
        } else {
            signatureBase64 = SignatureDataForPackedBy
        }
        setLoading(true);
        var raw = JSON.stringify({
            batchId: BatchParams.BatchId,
            schoolId: LogInSchoolID,
            batchPackerSignature: signatureBase64,
            batchReceiverSignature: null,
            adminBatchId: null,
            adminBatchDeliverSignature: null,
            adminBatchReceiverSignature: null,
            flag: 2,
            userId: LogInUserID
        });
        await ApiPostCall("/schools/batches/add-signature", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setSignatureModal(false);
                if (result == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Signature Added Successfully"} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                        AllBatches(BatchParams.searchString ? BatchParams.searchString : null, null, false);
                    }, 1500);
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 1500);
                }
            }
        });
    }
    function handleSearchChange(e) {
        setCurrentPage(1);
        AllBatches(e.target.value, null, false);
        setBatchParams({ ...BatchParams, searchString: e.target.value });
    }
    const signaturemodalbody = (
        <div className="col-12 py-1">
            <div className="greyBox">
                <div className='fw-600 font-15 text-center'>Packed By Signature:</div>
                <div className='mt-2 text-center'>
                    {SignatureDataForPackedBy ? (
                        <img src={SignatureDataForPackedBy} alt="Packed By Signature" />
                    ) : (
                        <SignatureCanvas
                            ref={sigCanvasForPackedBy}
                            canvasProps={{ width: 430, height: 100, className: "signatureCanvas" }}
                        />
                    )}
                </div>
                <div className="text-end"> <label className="cursor-pointer" onClick={clearSignatureForPackedBy}><u>Clear</u></label></div>
            </div>
            {ReceivedData.receivedname != '' && (
                <div className="col-12 p-3 text-start">
                    <b>Received By : </b>{ReceivedData.receivedname}
                    <br />
                    <b>Date Received : </b>{ReceivedData.receiveddate}
                </div>
            )}
        </div>
    )
    async function deleteShipment() {
        setLoading(true);
        var raw = JSON.stringify({
            trackingNumber: deletedData.trackingnum || null,
            schoolId: LogInSchoolID,
            batchId: deletedData.batchId,
            batchFlag: 2,
            loginUserId: LogInUserID,
            ticketIds: []
        })
        await ApiPostCall("/schools/batches/edit", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                if (responseRs.response == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={responseRs.msg} />);
                    setDeleteShipmentPopup(false);
                    setDeletedData({ ...deletedData, trackingnum: "", batchId: "" })
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                        AllBatches(BatchParams.searchString ? BatchParams.searchString : null, null, false);
                    }, 3500);
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 3500);
                }
            }
        });

    }
    return (
        <React.Fragment>
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"Outgoing Batches"} handleSearch={handleSearchChange}
                loading={loading} Alerts={Alerts} showsearch={true} />
            <div className="GridBox mt-2 p-3">
                <div className="row">
                    {state?.ShippingType == 2 && (
                        <div className="col-md-9">
                            <label className="blueText">*ShipStation Batches</label>
                        </div>
                    )}
                    <div className={`${state?.ShippingType == 2 ? 'col-md-3' : 'col-md-12'} text-end`}>
                        <div className="font-14 pb-1" style={{ color: 'black', cursor: 'pointer' }} onClick={() => navigate("/ship-devices")}><u>  Go to Tickets</u></div>
                    </div>

                </div>
                <div className="greyBox p-3">
                    <div className="row px-3">
                        <div className="greyBox py-0">
                            <div className="data-table-container" ref={tableWrapperRef}>
                                <table className="table data-table mb-0" >
                                    <thead className='GridHeader'>
                                        <tr>
                                            {columnNames?.map((item) => {
                                                const columnName = item.replace(/_/g, ' ');
                                                const transformedName = transformNameOfCol(columnName);
                                                if (!transformedName) return null;
                                                return (
                                                    <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${CamelCaseWithSpaces(transformedName)}`} onClick={() => handleSortClick(item)} >
                                                        {CamelCaseWithSpaces(transformedName)}
                                                        <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                                                    </th>
                                                );
                                            })}
                                            {UserData.signatureFlag == 1 && (
                                                <th scope="col" className='fw-600'>Signature </th>
                                            )}
                                            <th scope="col" className={`fw-600 ${isOverflowing ? 'sticky-action' : ''}`}>Action <img src="/images/EditHeaderIcon.svg" className="cursor-pointer img-fluid ps-2 pe-5" title='Customize Headers' style={{ height: '25px' }} onClick={(e) => setCustomizationModal(true)} /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Batches.length != 0 ?
                                            Batches.map((item, i) => {
                                                return (
                                                    <tr key={i} className={`OddEvenClass tableBorderHide ${item.batch_type == 2 && "blueText"}`}>

                                                        {columnNames?.map(header => (
                                                            <td className="py-12" key={header}>
                                                                {renderContentForColumn(header, item)}
                                                            </td>
                                                        ))}
                                                        {UserData.signatureFlag == 1 && (
                                                            <td>
                                                                <label title="Signature">
                                                                    <FontAwesomeIcon icon={faPencilAlt} title="Signature" className="ps-2 cursor-pointer"
                                                                        onClick={(e) => {
                                                                            setSignatureDataForPackedBy(item.batch_packer_signature);
                                                                            setSignatureModal(true);
                                                                            setBatchParams({ ...BatchParams, BatchId: item.id, BatchName: item.batch_name });
                                                                            setReceivedData({ ...ReceivedData, receiveddate: item.received_date || '', receivedname: item.received_by_user ? item.received_by_user?.first_name + ' ' + item.received_by_user?.last_name : '' })
                                                                        }}
                                                                        batchid={item.id} />
                                                                </label>
                                                            </td>
                                                        )}
                                                        <td className={`${isOverflowing ? 'sticky-action' : ''}`}>
                                                            {item.batch_type == 1 ?
                                                                <img src='/images/EditIconNew.svg' title="Add Devices Into Batch" className='img-fluid pe-2 cursor-pointer'
                                                                    onClick={(e) => navigate("/ship-devices", {
                                                                        state: {
                                                                            batchid: item.id,
                                                                            batchflag: item.batch_type,
                                                                            trackingnum: item.tracking_num
                                                                        }
                                                                    }, { replace: true })} />
                                                                : item.editflag == 1 ?
                                                                    <img src='/images/EditIconNew.svg' title="Add Devices Into Batch" className='img-fluid pe-2 cursor-pointer'
                                                                        onClick={(e) => { setDeletedData({ ...deletedData, trackingnum: item.tracking_num, batchId: item.id }); setDeleteShipmentPopup(true) }} />
                                                                    : <label className="pe-2">-</label>
                                                            }
                                                            <img src="/images/printlabelicon.svg" title="Show Packing List" className="img-fluid cursor-pointer pe-2" onClick={(e) => PrintPackingList(item.id)} style={{ height: 18 }} batchid={item.id} />
                                                            {item.batch_type != 2 &&
                                                                <img src="/images/DeleteIcon.svg" title="Delete Batch" style={{ height: "18px" }} className="img-fluid cursor-pointer"
                                                                    onClick={(e) => { setDeletePopup(true); setBatchParams({ ...BatchParams, BatchId: item.id }) }} batchid={item.id} />
                                                            }
                                                            {item.shipstation_label ?
                                                                <img src="/images/previewpdficon.svg" className="cursor-pointer ps-2" title="Preview ShipStation Document"
                                                                    onClick={(e) => ExtraDocument(item.shipstation_label)} style={{ height: "18px" }} batchid={item.id} />
                                                                : item?.label_url ?
                                                                    <img src="/images/previewpdficon.svg" className="cursor-pointer ps-2" title="Preview ShipStation Document"
                                                                        onClick={(e) => shipStationUrlTrack(item?.label_url)} style={{ height: "18px" }} batchid={item.id} />
                                                                    : schoolDetail == 2 ?
                                                                        <label title="Create Shipping">
                                                                            <FontAwesomeIcon icon={faShippingFast} style={{ color: "black" }} title="Create Shipping" className="ps-2 cursor-pointer" onClick={(e) => { setCreatebatch(true); setBatchParams({ ...BatchParams, BatchId: item.id, BatchName: item.batch_name }) }} batchid={item.id} />
                                                                        </label>
                                                                        : <>-</>
                                                            }

                                                        </td>
                                                    </tr>
                                                )
                                            })
                                            :
                                            <tr>
                                                <td colSpan={15} className="p-3 text-center">
                                                    No Record Found
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            {showPagination && (
                                <Pagination activePage={currentPage} totalItemsCount={pageRangeCount}
                                    pageRangeDisplayed={15} itemsCountPerPage={LimitForPagination} onChange={(e) => setCurrentPage(e)}
                                    color="primary" lastPageText="" firstPageText="" itemClassFirst="MasterClass" itemClassPrev="MasterClass"
                                    itemClassNext="MasterClass" itemClassLast="MasterClass" hideFirstLastPages={true} />
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {BatchParams.BatchTicketDataModal && <BatchDetailsPopup isShow={BatchParams.BatchTicketDataModal} ClosePopup={() => setBatchParams({ ...BatchParams, BatchTicketDataModal: false })} batchData1={batchData} AttachTicketData={AttachTicketData} />}
            <Deletepopup text={`You won't be able to revert this!`} deletePopup={deletePopup} size="xl" deletePart={DeleteBatch} DeleteShowClose={(e) => setDeletePopup(false)} />
            {createbatch && <CreateShippingCom schoolname={schoolname}
                ClosePopup={(e) => setCreatebatch(false)} isShow={createbatch} shippingFlag={2}
                batchname={BatchParams.BatchName} batchid={BatchParams.BatchId} AllBatches={AllBatches} />}
            {CustomizationModal && <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={'Outgoing Batches'} GetCall={(e) => ApiGetHeaders(4, setColumnNames)} />}
            {signatureModal && (
                <Popup isshow={signatureModal} size={"md"} title={"Signature"}
                    closePopup={(e) => { setSignatureModal(false) }}
                    modalBody={signaturemodalbody} handleSave={SaveSignatureCall} visibleSaveBtn={true} btnText={"Save"} />
            )}

            <Deletepopup text={`Delete this batch? To make changes, you must first delete this ShipStation batch and create a new one. Deleting this batch will cancel all shipping labels. Shipment cancellation request will fail if any package in this batch has already been scanned by the carrier or if the 24-hour refund window has expired.`}
                deletePopup={deleteShipmentPopup} size="xl" deletePart={deleteShipment} DeleteShowClose={(e) => setDeleteShipmentPopup(false)} />

            {showTrackingModal.show && (
                <TrackingDetailsPopup showModal={showTrackingModal.show} closePopup={() => setShowTrackingModal(initialTrackSate)} BatchId={showTrackingModal.BatchId} />
            )}
        </React.Fragment>
    )
}
export default Outgoingbatches
